module.exports = __webpack_public_path__ + "static/media/file-download.09d5f263.svg";